import React, { useEffect, useState } from 'react';
import { Input } from '../../../UI/InputElement/InputElement';
import { change, getFormValues, reduxForm } from 'redux-form';
import { locationAssociationValidation as validate } from '../../../../../utility/validator/validator';
import { connect, useDispatch } from 'react-redux';
import cloneDeep from 'clone-deep';
import  isEmpty  from '../../../../../utility/IsEmptyValidator';
import { makeFirstLetterCapital } from '../../../../../utility/utility';

const getFulfillmentManager = (props) => {

  return props.fulfillmentManager && props.fulfillmentManager.map(user => {
      return {
          id: user.id,
          name: makeFirstLetterCapital(user.first_name) + ' ' + makeFirstLetterCapital(user.last_name)
      }
  })
}

const getLocationName = (props) => {

  return props.locationName && props.locationName.map(location => {
      return {
          id: location.id,
          name: makeFirstLetterCapital(location.name) 
      }
  })
}

let NewLocationAssociation = (props) => {

  const [fulfillmentManager, setFulfillmentManager] = useState([]);
  const [locationName, setLocationName] = useState([])

  useEffect(() => {
    setFulfillmentManager(getFulfillmentManager(props))
  }, [props.fulfillmentManager])

  useEffect(() => {
    setLocationName(getLocationName(props))
  }, [props.locationName])



  const { handleSubmit, pristine, reset, submitting, error } = props;
  return (
      <div className="modal fade request_quote_modal reject_quot associateUser" id="addDeficiency" tabindex="-1" role="dialog" aria-labelledby="rejectQuoteModalTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <label for="exampleInputEmail1" className="cst-label md_title">{props.isEdit ? 'Update Location Association' : 'New Location Association'}</label>
              <button type="button" className="close close_icn_pic" data-dismiss="modal" onClick={()=> {props.closePopup(); }}><img src="/images/icons/icn_close_gray.png" alt="Close Icon" /></button>
            </div>

            <div className="modal-body">
              <div className="tab-content">
                <div id="profile" className="profile_tab cst_tab_content tab-pane fade show active edit_profile_modal">
                  <form className="form_content" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="label_modifier">Location</label>
                          <Input instanceId="job_select" disabled={props.isEdit} type="select" options={locationName ? locationName : []}    placeholder="Select Location" className="custom-select input-modifier add_user_select" name="location_association[location]" />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="label_modifier">Fulfilment Manager</label>
                          <Input type="select" options={fulfillmentManager ? fulfillmentManager : []}  placeholder="Select Fulfilment Manager" className="custom-select input-modifier add_user_select" name="location_association[fulfilment_manager]" />
                        </div>
                      </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="modal-footer">
                      <button type="submit" disabled={props.isLoading ? true : false} className={props.isLoading ? "btn cst_btn btn_danger mr-2 btn-wait" : "btn cst_btn btn_danger mr-2"} >{props.isLoading ? "" : "Save"}</button>
                      <button onClick={() => {props.closePopup();}} type="button" className="btn btn-outline-secondary cst_btn" id='deficiencyClose' data-dismiss="modal">Close</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

const mapStateToProps = (state) => {

  let location_association = {}

  if (!isEmpty(state.InventoryReducer.locationAssociate)) {

    const value = state.InventoryReducer.locationAssociate
    location_association['location']= value ?  value.id : ''
    location_association['fulfilment_manager']= value && value.user ? value.user.id : ''
  }

  return { initialValues: {location_association} }
}

NewLocationAssociation = reduxForm({
  form: 'locationAssociationForm',
  validate,
  enableReinitialize: true
})(NewLocationAssociation);

NewLocationAssociation = connect(mapStateToProps)(NewLocationAssociation)

export default NewLocationAssociation;